import React from 'react';
import { useNavigate, Link } from 'react-router-dom';

const TermsOfUse = () => {
    const containerStyles = {
        marginLeft: '40px', // Adjust as needed
        marginRight: '20px', // Adjust as needed
    };

    const headingStyles = {
        color: 'yellow',
        marginTop: '20px', // Add spacing before each heading
    };

    const textStyles = {
        color: 'white',
    };

    return (
      <div className="flex flex-col bg-black">
        <header className="bg-black text-white border-b border-blue-400 px-4 py-6 w-full">
          <h2 className="text-xl lg:text-2xl text-yellow-200 font-bold text-center">
            Think5Whys Terms of Use
          </h2>
        </header>
        <div className="mx-auto px-4 py-8 bg-black text-white shadow-lg rounded-lg">
          <p className="text-gray-300 text-lg font-semibold mb-4">
            Effective Date: 01 August 2026
          </p>
          <div className="bg-black p-10 rounded-lg shadow-lg border border-blue-400">
            <h1 className="text-xl lg:text-2xl font-bold text-white mb-6 text-center">
              Welcome to Think5Whys Global DeepTech Solutions!
            </h1>

            <p className="text-gray-100 mb-4">
              These terms and conditions outline the rules and regulations for
              the use of our website, located at [Your Website URL].
            </p>

            <p className="text-gray-100 mb-4">
              By accessing this website, we assume you accept these terms and
              conditions. Do not continue to use Think5Whys Global DeepTech
              Solutions if you do not agree to take all of the terms and
              conditions stated on this page.
            </p>

            <p className="text-gray-100 mb-4">
              The following terminology applies to these Terms of Use, Privacy
              Statement, and Disclaimer Notice and all Agreements: "Client",
              "You," and "Your" refers to you, the person logging on to this
              website and compliant with the Company's terms and conditions.
              "The Company," "Ourselves," "We," "Our," and "Us," refers to our
              Company. "Party," "Parties," or "Us," refers to both the Client
              and ourselves.
            </p>

            <h2 className="text-lg lg:text-xl font-semibold text-yellow-200 mt-8 mb-4">
              1. Cookies
            </h2>
            <p className="text-gray-100 mb-4">
              We employ the use of cookies. By accessing Think5Whys Global
              DeepTech Solutions, you agreed to use cookies in agreement with
              the Think5Whys Global DeepTech Solutions' Privacy Policy.
            </p>

            <h2 className="text-lg lg:text-xl font-semibold text-yellow-200 mt-8 mb-4">
              2. License
            </h2>
            <p className="text-gray-100 mb-4">
              Unless otherwise stated, Think5Whys Global DeepTech Solutions
              and/or its licensors own the intellectual property rights for all
              material on Think5Whys Global DeepTech Solutions. All intellectual
              property rights are reserved.
            </p>

            <h2 className="text-lg lg:text-xl font-semibold text-yellow-200 mt-8 mb-4">
              3. You must not:
            </h2>
            <ul className="list-disc pl-5 text-gray-100 mb-4">
              <li className="text-gray-100">
                Republish material from Think5Whys Global DeepTech Solutions
              </li>
              <li className="text-gray-100">
                Sell, rent, or sub-license material from Think5Whys Global
                DeepTech Solutions
              </li>
              <li className="text-gray-100">
                Reproduce, duplicate, or copy material from Think5Whys Global
                DeepTech Solutions
              </li>
              <li className="text-gray-100">
                Redistribute content from Think5Whys Global DeepTech Solutions
              </li>
            </ul>

            <h2 className="text-lg lg:text-xl font-semibold text-yellow-200 mt-8 mb-4">
              4. Hyperlinking to our Content
            </h2>
            <p className="text-gray-100 mb-4">
              The following organizations may link to our Website without prior
              written approval:
            </p>
            <ul className="list-disc pl-5 text-gray-100 mb-4">
              <li className="text-gray-100">Government agencies</li>
              <li className="text-gray-100">Search engines</li>
              <li className="text-gray-100">News organizations</li>
              <li className="text-gray-100">Online directory distributors</li>
            </ul>

            <h2 className="text-lg lg:text-xl font-semibold text-yellow-200 mt-8 mb-4">
              5. iFrames
            </h2>
            <p className="text-gray-100 mb-4">
              Without prior approval and written permission, you may not create
              frames around our Webpages that alter in any way the visual
              presentation or appearance of our Website.
            </p>

            <h2 className="text-lg lg:text-xl font-semibold text-yellow-200 mt-8 mb-4">
              6. Content Liability
            </h2>
            <p className="text-gray-100 mb-4">
              We shall not be held responsible for any content that appears on
              your Website. You agree to protect and defend us against all
              claims that are rising on your Website.
            </p>

            <h2 className="text-lg lg:text-xl font-semibold text-yellow-200 mt-8 mb-4">
              7. Reservation of Rights
            </h2>
            <p className="text-gray-100 mb-4">
              We reserve the right to request that you remove all links or any
              particular link to our Website.
            </p>

            <h2 className="text-lg lg:text-xl font-semibold text-yellow-200 mt-8 mb-4">
              8. Removal of links from our website
            </h2>
            <p className="text-gray-100 mb-4">
              If you find any link on our Website that is offensive for any
              reason, you are free to contact us.
            </p>

            <h2 className="text-lg lg:text-xl font-semibold text-yellow-200 mt-8 mb-4">
              9. Disclaimer
            </h2>
            <p className="text-gray-100 mb-4">
              To the maximum extent permitted by applicable law, we exclude all
              representations, warranties, and conditions relating to our
              website.
            </p>
          </div>
        </div>

        <footer className="bg-black border-t border-blue-800 text-white py-4 w-full mt-auto">
          <div className="w-full px-2 sm:px-4">
            <div className="flex flex-col md:flex-row items-center justify-between gap-3">
              <div className="text-xs sm:text-sm lg:text-lg text-yellow-200 text-center md:text-left break-words">
                © {new Date().getFullYear()} Think5Whys Global DeepTech
                Solutions.
              </div>
              <nav className="flex flex-wrap justify-center md:justify-end gap-2 sm:gap-4 text-xs sm:text-sm">
                <Link
                  to="/about-us"
                  className="text-white hover:text-yellow-200"
                >
                  About
                </Link>
                <Link
                  to="/privacy-policy"
                  className="text-white hover:text-yellow-200"
                >
                  Privacy Policy
                </Link>
                <Link
                  to="/terms-of-use"
                  className="text-white hover:text-yellow-200"
                >
                  Terms of Use
                </Link>
                <Link
                  to="/contact-us"
                  className="text-white hover:text-yellow-200"
                >
                  Contact
                </Link>
              </nav>
            </div>
          </div>
        </footer>
      </div>
    );
};

export default TermsOfUse;
